<div class="flex justify-center">
    <h2 class="font-light leading-relaxed text-2xl py-8 text-gray-800 cursor-default"
        style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Actions done in {{city}}</h2>
</div>
<div class="w-1/2 px-8 py-4 mx-auto">
    <div class="shadow">
        <div class="border-b">
            <div class="border-l-2 border-transparent">
                <ng-container *ngFor="let data of data; index as i;">
                    <div class="grid grid-cols-1 p-1 text-grey-800 text-justify">
                        <div class="flex justify-center text-xl p-2 font-light cursor-pointer rounded-md text-gray-100"
                            [class.cia]="data.Action_Cat === 'CIA-FOOD CONSUMER'"
                            [class.dia]="data.Action_Cat === 'DIA-FOOD DISTRIBUTION'"
                            [class.gia]="data.Action_Cat === 'GIA-FOOD GOVERNANCE'"
                            [class.pia]="data.Action_Cat === 'PIA-FOOD PRODUCTION AND PROCESSING'"
                            [class.wia]="data.Action_Cat === 'WIA-FOOD WASTE'" (click)="onClick($event.target.value)"
                            value="{{data.Action_Cat}}">
                            {{data.Action_Cat}} &nbsp;
                            <div class="rounded-full border border-grey w-7 h-7 flex items-center justify-center pointer-events-none"
                                *ngIf="!data.expanded">
                                <svg aria-hidden="true" data-reactid="266" fill="none" height="24" stroke="#F5F5F5"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24"
                                    width="24" xmlns="http://www.w3.org/2000/svg">
                                    <polyline points="6 9 12 15 18 9">
                                    </polyline>
                                </svg>
                            </div>
                            <div class="rounded-full border border-grey w-7 h-7 flex items-center justify-center pointer-events-none"
                                *ngIf="data.expanded">
                                <svg aria-hidden="true" data-reactid="266" fill="none" height="24" stroke="#F5F5F5"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24"
                                    width="24" xmlns="http://www.w3.org/2000/svg">
                                    <polyline points="18 15 12 9 6 15">
                                    </polyline>
                                </svg>
                            </div>
                        </div>
                        <div *ngIf="data.expanded">
                            <div *ngFor="let action of actions[i]">
                                <div class="shadow">
                                    <div class="border-b">
                                        <div class="border-l-2 border-transparent">
                                            <div class="p-1 text-lg font-thin rounded hover:bg-colortext hover:text-yellow-200 cursor-pointer"
                                                (click)="onActionClick($event.target.value)" value="{{action}}">
                                                {{action}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>